import { Route } from '../../../shared/router';
import { DemoPage, DemoArtPage } from '../pages';

export const routes: Route[] = [
  {
    name: 'demo',
    title: 'Demo',
    path: '/demo/start',
    component: DemoPage,
    layoutType: 'publicMain',
    isPublic: true,
    onlyNonAuth: false,
    availableFor: 'consumer',
  },
  {
    name: 'demo art',
    title: 'Demo art',
    path: '/demo/art',
    component: DemoArtPage,
    layoutType: 'publicMain',
    isPublic: true,
    onlyNonAuth: false,
    availableFor: 'consumer',
  }
];
